export default "__VITE_ASSET__zAfsrYYp__"